// src/components/drawer/drawer-trigger.tsx
import * as Dialog from "@radix-ui/react-dialog";
import React, { forwardRef } from "react";
var DrawerTrigger = forwardRef(
  function DrawerTrigger2(props, ref) {
    return /* @__PURE__ */ React.createElement(Dialog.Trigger, { ref, ...props });
  }
);

export {
  DrawerTrigger
};
